<template>
  <modal-template
    ref="modal"
    :title="title"
    type-modal="add_obligations_modal"
  >
    <div class="modal-content__main">
      <ul class="list-inline">
        <draggable
          v-model="selectedList"
          tag="div"
          ghost-class="ghost"
          handle=".handle"
          draggable=".draggable-item"
        >
          <li
            v-for="(item, index) in selectedList"
            :key="item.id"
            class="contract-detail text-left d-flex align-items-start pr-3 draggable-item py-1"
          >
            <div class="contract-detail__controls">
              <span class="index-item text-center font-weight-bold">{{ index + 1 }}</span>
              <i class="fa fa-align-justify handle"></i>
              <d-checkbox
                toggle
                @change="toggleItem(item)"
                :checked="item.selected"
                class="custom-toggle-sm"
              >
              </d-checkbox>
            </div>
            <div class="contract-detail__text" @click="toggleItem(item)" v-html="item.name" v-if="item.name"></div>
          </li>
        </draggable>
        <li
          v-for="item in unselectedList"
          :key="item.id"
          class="contract-detail text-left d-flex align-items-start pr-3 no-content py-1"
        >
          <div class="contract-detail__controls">
            <span class="index-item text-center font-weight-bold"></span>
            <span class="handle-spacer"></span>
            <d-checkbox
              toggle
              @change="toggleItem(item)"
              :checked="item.selected"
              class="custom-toggle-sm"
            >
            </d-checkbox>
          </div>
          <div class="contract-detail__text" @click="toggleItem(item)" v-html="item.name" v-if="item.name"></div>
        </li>
      </ul>
    </div>
    <div slot="actions" class="modal-content__control">
      <span class="modal-content__hint">
        Ao inserir, o conteúdo atual do editor será substituído pelos itens selecionados nesta lista.
      </span>
      <div class="d-flex align-items-center">
        <loader v-if="loading" :fullPage="false" class="mr-4"/>
        <d-button
          type="button"
          :disabled="loading"
          @click="save()"
          class="btn btn-sm btn-primary"
        >Inserir</d-button>
      </div>
    </div>
  </modal-template>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import draggable from 'vuedraggable';
import { OPTION } from '_modules/settings/components/SettingsModel';
import Loader from '_shared/Loader.vue';
import ModalTemplate from '_shared/Modal.vue';
import { _OPEN_OBLIGATION_MODAL_, _SET_OBLIGATION_IN_QUOTATION_ } from '../QuotationModel';

const TEXT_EMPTY = '';
const TEXT_SPACE = ' ';
const TEXT_ELEMENT_DIV = 'div';
const TEXT_ELEMENT_LI = 'li';
const TEXT_ELEMENT_P = 'p';
const TEXT_NORMALIZATION = 'NFD';
const TEXT_DIACRITICS_REGEX = /[\u0300-\u036f]/g;
const TEXT_WHITESPACE_REGEX = /\s+/g;

export default {
  name: 'contractual-items-select-modal',
  data() {
    return {
      selectedList: [],
      unselectedList: [],
      type: null,
      index: null,
      loading: false,
    };
  },
  components: {
    Loader,
    ModalTemplate,
    draggable,
  },
  computed: {
    catalog() {
      const items = this.$store.state.settings[this.type];
      if (items && items.length > 0) {
        return items;
      }
      return [{ ...OPTION }];
    },
    title() {
      return this.type === 'itemsIncluded' ? 'Selecionar Itens Inclusos' : 'Selecionar obrigações';
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    toggleItem(item) {
      if (item.selected) {
        item.selected = false;
        const selectedIndex = this.selectedList.findIndex(row => row.id === item.id);
        if (selectedIndex > -1) this.selectedList.splice(selectedIndex, 1);
        this.unselectedList.push(item);
        return;
      }

      item.selected = true;
      const unselectedIndex = this.unselectedList.findIndex(row => row.id === item.id);
      if (unselectedIndex > -1) this.unselectedList.splice(unselectedIndex, 1);
      this.selectedList.push(item);
    },
    save() {
      const obligation = this.selectedList.map(row => row.name).join('');

      if (!obligation) {
        this.activeAlert({ message: 'Selecione pelo menos um item para inserir.', theme: 'warning' });
        return;
      }

      Events.$emit(_SET_OBLIGATION_IN_QUOTATION_, ({ obligation, type: this.type, index: this.index }));
      this.setToggle({ type: 'add_obligations_modal', bool: false });
    },
    normalizeHtmlText(html) {
      if (!html) return TEXT_EMPTY;

      const div = document.createElement(TEXT_ELEMENT_DIV);
      div.innerHTML = html;

      return (div.textContent || TEXT_EMPTY)
        .replace(TEXT_WHITESPACE_REGEX, TEXT_SPACE)
        .trim()
        .normalize(TEXT_NORMALIZATION)
        .replace(TEXT_DIACRITICS_REGEX, TEXT_EMPTY)
        .toLowerCase();
    },
    extractBlockTexts(html) {
      if (!html) return [];

      const div = document.createElement(TEXT_ELEMENT_DIV);
      div.innerHTML = html;

      const blocks = [...div.querySelectorAll(`${TEXT_ELEMENT_LI}, ${TEXT_ELEMENT_P}`)]
        .filter(el => el.tagName.toLowerCase() === TEXT_ELEMENT_LI || !el.closest(TEXT_ELEMENT_LI))
        .map(el => this.normalizeHtmlText(el.innerHTML))
        .filter(Boolean);

      if (blocks.length) return blocks;

      const text = this.normalizeHtmlText(html);
      return text ? [text] : [];
    },
    loadList(html) {
      const texts = this.extractBlockTexts(html);

      this.selectedList = texts
        .map(text => this.catalog.find(item => item.id && this.normalizeHtmlText(item.name) === text))
        .filter(Boolean)
        .map(item => ({ ...item, selected: true }));

      const selectedIds = new Set(this.selectedList.map(item => item.id));

      this.unselectedList = this.catalog
        .filter(item => item.id && !selectedIds.has(item.id))
        .map(item => ({ ...item, selected: false }));
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_OPEN_OBLIGATION_MODAL_, ({ type, index, html }) => {
      this.type = type;
      this.index = index;
      this.loadList(html);
    });
  },
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px;
  }
}
</style>
<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-content__hint {
  color: #6c757d;
  font-size: 0.85rem;
  margin-right: 1rem;
  font-weight: 600;
}
.contract-detail {
  cursor: pointer;
  display: flex;
  align-items: flex-start;

  /deep/ p {
    margin-bottom: 10px;
  }
}
.contract-detail__controls {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  height: 1.5em;
  margin-right: 0.5rem;
}
.handle {
  cursor: grab;
  color: #c0c4cc;
  width: 14px;
  margin-right: 0.5rem;
  text-align: center;
}
.handle-spacer {
  display: inline-block;
  width: 14px;
  margin-right: 0.5rem;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.contract-detail__text {
  flex: 1;
  min-width: 0;
  line-height: 1.5;
}
.custom-toggle-sm {
  margin: 0;
}
.index-item {
  min-width: 14px;
  margin-right: 0.5rem;
  text-align: center;
  font-variant-numeric: tabular-nums;
}
</style>
